import { useMemo } from 'react';
import { useFetchQuery } from '@atlassian/jira-relay-utils/src/services/use-fetch-query/index.tsx';
import type {
	gqlGetComponentScorecardsQuery$data,
	gqlGetComponentScorecardsQuery$variables,
} from '@atlassian/jira-relay/src/__generated__/gqlGetComponentScorecardsQuery.graphql';
import type { Scorecard, ScorecardScore } from '../../common/utils.tsx';
import { GET_COMPASS_COMPONENTS_SCORECARDS_QUERY } from './gql.tsx';

export const useGetComponentScorecards = (componentId: string) => {
	const { data, loading, error } = useFetchQuery<
		gqlGetComponentScorecardsQuery$variables,
		gqlGetComponentScorecardsQuery$data
	>(GET_COMPASS_COMPONENTS_SCORECARDS_QUERY, { componentId });

	const scorecards: Scorecard[] = useMemo(() => {
		if (!loading && data?.compass?.component?.__typename === 'CompassComponent') {
			const dataFields = data.compass.component.scorecards ?? [];
			return dataFields?.map(
				(field) =>
					// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
					({
						id: field?.id ?? '',
						name: field?.name ?? '',
						// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
						scorecardScore: {
							totalScore: field.scorecardScore?.totalScore ?? 0,
							maxTotalScore: field.scorecardScore?.maxTotalScore ?? 0,
						} as ScorecardScore,
					}) as Scorecard,
			);
		}
		return [];
	}, [data, loading]);

	return {
		scorecards,
		loading,
		error,
	};
};
